/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    CODE: 'Código',
    COUNTERPARTS: 'Contraprestaciones',
    CURRENT: 'Actual',
    GENERAL_INFORMATION: 'Información general',
    MANAGER: 'Gestor',
    PREVIOUS: 'Anterior',
    PRODUCTS: 'Productos',
    REMUNERATION: 'Remuneraciones',
    SUPERVISOR: 'Supervisor'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
